import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';

import Ajax from '../ajax/Ajax';

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

class HexDescription extends Component {
	
	constructor(props) {
		super(props);
		var hexId = this.props.hexId;
		var description = this.props.description;
		var edit = this.props.edit;
		var selected = this.props.selected;
		var update = this.props.update;
		this.state = {hexId: hexId, selected: selected, edit: edit, description: description, update: update, overlay: false};
		
		this.updateTitle = this.updateTitle.bind(this);
		this.updateContent = this.updateContent.bind(this);
		this.updateIcon = this.updateIcon.bind(this);
		this.addImage = this.addImage.bind(this);
		this.showImage = this.showImage.bind(this);
		this.closeOverlay = this.closeOverlay.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
	}
	
	componentWillReceiveProps(nextProps) {
		var hexId = nextProps.hexId;
		var description = nextProps.description;
		var edit = nextProps.edit;
		var selected = nextProps.selected;
		this.setState({hexId: hexId, selected: selected, edit: edit, description: description});  
	}
	
	showImage(img) {
		var obj = this;
		return function(event) {
			obj.setState({overlay: img});
		};
	}
	
	closeOverlay(event) {
		this.setState({overlay: false});
	}
	
	deleteImage(remove) {
		var obj = this;
		return function(event) {
			event.stopPropagation();
			var description = obj.state.description;
			if (! description) 
				return
			var imgs = description.imgs;
			if (! (typeof imgs === "undefined")) {
				var newImgs = [];
				for (var idx in imgs) {
					var img = imgs[idx];
					if (img !== remove)
						newImgs.push(img);
				}
				description.imgs = newImgs;
				obj.setState({description: description, overlay: false});
				obj.state.update(obj.state.hexId, description);
			}
		};
	}
	
	addImage(event) {
		var img = event.target.files[0];
		console.log(img);
		var obj = this;
		if (img.name.length > 0)
			Ajax.uploadFile(img).then(function (result) {
				if (result === "FAIL")
					return;
				var description = obj.state.description;
				if (! description) description = {};				
				var imgs = description.imgs;
				if (typeof imgs === "undefined") {
					imgs = [];
				}
				imgs.push(result);
				description.imgs = imgs;
				obj.setState({description: description});
				obj.state.update(obj.state.hexId, description);
			});
	}
	
	updateTitle(event) {
		var title = event.currentTarget.innerText;
		var description = this.state.description;
		if (! description) description = {};
		description.title = title;
		this.setState({description: description});
		this.state.update(this.state.hexId, description);
	}
	
	updateContent(event) {
		var content = event.currentTarget.innerText;		
		var description = this.state.description;
		if (! description) description = {};
		description.content = content;
		this.setState({description: description});
		this.state.update(this.state.hexId, description);
	}
	
	updateIcon(icon) {
		var obj = this;
		return function(event) {
			if (icon === "ban") {
				$(".HexDescriptionIconOptionSelected").removeClass("HexDescriptionIconOptionSelected");
				var description = obj.state.description;
				if (! description) return;
				delete description.icon;
				obj.setState({description: description});
				obj.state.update(obj.state.hexId, description);
			} 
			else {
				$(".HexDescriptionIconOptionSelected").removeClass("HexDescriptionIconOptionSelected");
				$("#" + icon).addClass("HexDescriptionIconOptionSelected");	
				var description = obj.state.description;
				if (! description) description = {};
				description.icon = icon;
				obj.setState({description: description});
				obj.state.update(obj.state.hexId, description);
			}			
		}
	}		
	
	
	render() {
		var description = this.state.description;
		if (isEmpty(description))
			description = false;
		var title = description ? description.title : "Titre";
		var content = description ? description.content : "Contenu";
		var imgs = description ? description.imgs : [];
		var descriptionIcon = description ? description.icon : false;
		
		var overlay = this.state.overlay;
		
		var contentAvailable = true;
		
		if (title === "" || typeof title === "undefined" || title === "Titre") {
			title = "Titre";
			contentAvailable = false;
		}
			
		
		if (content ==="" || typeof content === "undefined")
			content = "Contenu";
		
		var icons = ["ban", "dot-circle", "question-circle", "exclamation-triangle", "fire", "certificate", "anchor"];
		
		var selected = this.state.selected;
		var edit = this.state.edit;
		
		var obj = this;
		
		if (! selected) {
			return (
			<div className="HexDescription">
				<div className="TopBorder orange" />
				<div className="BottomBorder orange" />
				<div className="HexDescriptionUnknown">
					<p>Sélectionnez une Zone</p>
				</div>
			</div>
			);
		}
		
		if (edit) {
			return (	
			<div className="HexDescription">
				{ overlay ? (<div className="ImageOverlay" id="overlay" onClick={this.closeOverlay}><img src={overlay} /></div>) : null }
				<div className="TopBorder orange" />
				<div className="BottomBorder orange" />				
				<div className="HexDescriptionTitle single-line" contentEditable={edit} onBlur={this.updateTitle}>{title}</div>
				<div className="HexDescriptionIcon">
					<div className="HexDescriptionIconTitle">Icone (carte):</div>
					{ 
						icons.map(function(icon, idx) {
							if (icon === descriptionIcon)
								return (<div id={icon} className="HexDescriptionIconOption HexDescriptionIconOptionSelected" onClick={obj.updateIcon(icon)}><FontAwesomeIcon icon={icon}/></div>);
							else
								return (<div id={icon} className="HexDescriptionIconOption" onClick={obj.updateIcon(icon)}><FontAwesomeIcon icon={icon}/></div>);
						})
					}
				</div>
				<p className="HexDescriptionContent" contentEditable={edit} onBlur={this.updateContent}>{content}</p>
				<div className="HexImages">
					<div className="HexImagesTitle">Images</div>
					{
						typeof imgs === "undefined" ? null : imgs.map(function(img, idx) {
							return (
							<div className="HexImage" key={idx} onClick={obj.showImage(img)} style={{backgroundImage: 'url(' + img + ')'}}>
								<div className="HexImageDelete" onClick={obj.deleteImage(img)}><FontAwesomeIcon icon="trash"/></div>
							</div>
							);
						})
					}
						<label htmlFor="imageUpload">
							<div className="HexImage HexImageAdd" key="addImage">
								<FontAwesomeIcon icon="plus-circle"/>
							</div>	
						</label>
						<input type="file" id="imageUpload" onChange={obj.addImage} accept="image/*"/>
				</div>
			</div>
			);
		}
		else if (description && contentAvailable) {
			return (
			<div className="HexDescription">
				{ overlay ? (<div className="ImageOverlay" id="overlay" onClick={this.closeOverlay}><img src={overlay} /></div>) : null }
				<div className="TopBorder orange" />
				<div className="BottomBorder orange" />
				<div className="HexDescriptionTitle">{title}</div>
				<p className="HexDescriptionContent" dangerouslySetInnerHTML={{__html: content}}></p>
				<div className="HexImages">
					{ typeof imgs !== "undefined" ? (<div className="HexImagesTitle">Images</div>) : null }
					{
						typeof imgs !== "undefined" ? imgs.map(function(img, idx) {
							return (<div className="HexImage" key={idx} onClick={obj.showImage(img)} style={{backgroundImage: 'url(' + img + ')'}}></div>);
						}) : null
					}
				</div>
			</div>
			);
		} else {
			return (
			<div className="HexDescription">
				<div className="TopBorder orange" />
				<div className="BottomBorder orange" />
				<div className="HexDescriptionUnknown">
					<FontAwesomeIcon icon="question"/><br/>
					<p>Zone Inexplorée</p>
				</div>
			</div>
			);
		}
	}
}

export default HexDescription;
